import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"44px"}},[(_vm.back)?_c(VBtn,{staticClass:"back_btn mt-2 mr-3",attrs:{"small":"","tile":"","color":"default"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c(VIcon,[_vm._v("arrow_back")])],1):_vm._e(),_c('h6',{staticClass:"title text-uppercase",staticStyle:{"min-height":"32px"}},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"staff_subtitle"},[_vm._v(_vm._s(_vm.subtitle))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }